import { render } from "./PromptBox.vue?vue&type=template&id=10698ab2&scoped=true"
import script from "./PromptBox.vue?vue&type=script&lang=js"
export * from "./PromptBox.vue?vue&type=script&lang=js"

import "./PromptBox.vue?vue&type=style&index=0&id=10698ab2&lang=less&scoped=true"

import exportComponent from "/Users/kk/ulu/dev/UstoreWebPayPC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10698ab2"]])

export default __exports__